/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandXbox = createReactComponent("brand-xbox", "IconBrandXbox", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M6.5 5c7.72 2.266 10.037 7.597 12.5 12.5", key: "svg-1" }],
  ["path", { d: "M17.5 5c-7.72 2.266 -10.037 7.597 -12.5 12.5", key: "svg-2" }]
]);

export { IconBrandXbox as default };
//# sourceMappingURL=IconBrandXbox.js.map
